import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/Users/arowaisi/Documents/ManaPNL/Frontend/node_modules/nextjs-toploader/dist/index.js");
;
import(/* webpackMode: "eager" */ "/Users/arowaisi/Documents/ManaPNL/Frontend/src/assets/scss/app.scss");
;
import(/* webpackMode: "eager" */ "/Users/arowaisi/Documents/ManaPNL/Frontend/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/arowaisi/Documents/ManaPNL/Frontend/src/components/wrappers/AppProvidersWrapper.tsx");
